import { EmailAPI } from '@business/api/email';
import { GmailMessageId, GmailMessageResponse, SendEmailRequest } from '@business/entities/gmail_messages';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';

export class EmailBloc extends BaseBloc {
  private readonly emailRepo = new Repository<GmailMessageResponse>({
    getItemId: email => email.id,
  });

  readonly selectItem = this.emailRepo.selectItem;

  onReset() {
    this.emailRepo.reset();
  }

  fetchEmail = (id: GmailMessageId) => {
    return EmailAPI.fetchEmail(id).pipe(
      this.emailRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_pros_error') }),
    );
  };

  sendReply = (id: GmailMessageId, data: SendEmailRequest) => {
    return EmailAPI.sendReply(id, data).pipe(
      this.emailRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('send_email_reply'),
      }),
    );
  };
}
